import PageNavBackLayoutCpt from '@/components/page/PageNavBackLayoutCpt';
import CodeDataPickerCpt from '@/components/data-picker/CodeDataPickerCpt';
import PopupDateTimeCpt from '@/components/date-time/PopupDateTimeCpt';
import { mapGetters } from 'vuex';
import cptCmn from '@/mixin/cpt-cmn';
import { rqtGetCustomerVisitSave } from '@/services/cms/customer';
const CustomerQuery2Cpt = () => import('@/components/customer/CustomerQuery2Cpt');
export default {
  mixins: [cptCmn],
  components: {
    PageNavBackLayoutCpt,
    CodeDataPickerCpt,
    PopupDateTimeCpt,
    CustomerQuery2Cpt
  },
  data() {
    return {
      btnLoading: false,
      form: {
        visitTime: undefined,
        visitType: {
          text: undefined,
          value: undefined
        },
        visitAction: {
          text: undefined,
          value: undefined
        },
        visitContent: undefined,
        nextVisitTime: undefined
      },
      fItemDataIndex: undefined,
      codeResItems: [{
        title: ' 拜访类型',
        dataIndex: 'visitType',
        dataType: 'select',
        dataRes: undefined,
        dataResItem: {
          key: 'code',
          title: 'codeName'
        },
        dataResCodeType: 'customerVisitType'
      }, {
        title: '拜访动作',
        dataIndex: 'visitAction',
        dataType: 'select',
        dataRes: undefined,
        dataResItem: {
          key: 'code',
          title: 'codeName'
        },
        dataResCodeType: 'customerVisitAction'
      }],
      customer: {}
    };
  },
  computed: {
    ...mapGetters('account', ['user'])
  },
  mounted() {
    this.initResCodeType(this.codeResItems);
  },
  methods: {
    onPickerCodeSelectClick(dataIndex, type) {
      this.fItemDataIndex = dataIndex;
      this.$refs['CodeDataPickerCpt'].showView(type || dataIndex);
    },
    onPickerCodeSelected(selectedValues, selectedOptions) {
      this.form[this.fItemDataIndex].text = selectedOptions[0].codeName;
      this.form[this.fItemDataIndex].value = selectedValues[0];
    },
    onPopupDateTimeSelectClick(dataIndex) {
      this.fItemDataIndex = dataIndex;
      this.$refs['PopupDateTimeCpt'].showView();
    },
    onDateTimeSelectedChange(val) {
      this.form[this.fItemDataIndex] = val;
    },
    getRightIcon(fieldName) {
      return !this.form[fieldName] ? '' : 'close';
    },
    onRightIconClick(fieldName) {
      this.form[fieldName] = undefined;
    },
    onSubmit() {
      this.btnLoading = true;
      const param = {};
      for (const key in this.form) {
        switch (key) {
          case 'visitAction':
          case 'visitType':
            param[key] = this.form[key].value;
            break;
          default:
            param[key] = this.form[key];
            break;
        }
      }
      rqtGetCustomerVisitSave({
        customerId: this.customer.id,
        customerVisitContentVOList: [param]
      }).then(() => {
        this.btnLoading = false;
        this.$message.success('操作成功');
        this.$router.go(-1);
      }).catch(() => {
        this.btnLoading = false;
      });
    },
    onSelectCustomerClick() {
      this.$refs['CustomerQuery2Cpt'].showView();
    },
    onCustomerSelected(value) {
      this.customer = value;
    }
  }
};